/**
 * 行业资讯首页路径
 */
export const NEWS_HOME_PAGE_PATH = '/news'
